import { useCallback } from 'react';

import { Button } from '../../components';

import {
  buttonClassName,
  headingClassName,
  notFoundContainer,
  subheadingClassName,
} from './styles';

const NotFoundContainer = () => {
  const onClick = useCallback(() => {
    window.location.href = '/';
  }, []);

  return (
    <div className={notFoundContainer}>
      <h2 className={headingClassName}>Oops!</h2>
      <h4 className={subheadingClassName}>
        We couldn't find the page you were looking for.
      </h4>
      <Button className={buttonClassName} onClick={onClick} primary>
        Go home
      </Button>
    </div>
  );
};

NotFoundContainer.displayName = 'NotFoundContainer';

export default NotFoundContainer;
